export default {
  common: {
    chiller: "Refroidisseur",
    chilledWaterPump: "Pompe à eau réfrigérée",
    coolingTower: "Tour de refroidissement",
    nextStep: "Étape suivante",
    previousStep: "Étape précédente",
    objective: "Objectif",
    preRetrofit: "État avant rénovation",
    postRetrofit: "État après rénovation",
    retrofitSetup: "Configuration de la rénovation",
    equipmentRated: "Équipement noté/évalué",
    retrofitSummary: "Résumé de la rénovation",
    cwp: "CWP (Pompe à eau réfrigérée)",
    condenderWaterPump: "Pompe à eau de condensation",
    chwp: "CHWP (Pompe à eau de refroidissement)",
    ct: "CT (Tour de refroidissement)",
    other: "Autre",
    otherEquipment: "Autre équipement",
    chillerOneNos: "Refroidisseur (1 unité)",
    condenderWaterPumpOneNos: "Pompe à eau de condensation (1 unité)",
    chilledWaterPumpOneNos: "Pompe à eau réfrigérée (1 unité)",
    coolingTowerFanOneNos: "Tour de refroidissement (1 unité)",
    dryCooler: "Refroidisseur à sec",
    controlOptimization: "Optimisation du contrôle",
    commonHeader: "Collecteur commun",
    dedicatedOneOnOne: "Dédié (1-1)",
    pleaseInput: "Veuillez saisir",
    pleaseEnterHere: "Veuillez entrer ici",
    cancel: "Annuler",
    Confirm: "Confirmer",
    years: "Années",
    noProjectInfo: "Aucune information sur le projet",

    pleaseInputData: "Veuillez entrer les données",
    systemOptionRequired: "Les options système sont requises",
    proposedEquipmentRequired: "Équipement à recommander"
  },
  objective: {
    projectObjective: "Objectif du projet",
    chillerEfficiency: "Efficacité du refroidisseur",
    chillerPlantEfficiency: "Efficacité de la centrale frigorifique",
    heatingEfficiency: "Efficacité du chauffage",
    heatingPlantEfficiency: "Efficacité de la centrale de chauffage",
    chillerHeatingEfficiency: "Efficacité du refroidisseur en mode chauffage",
    pleaseSelectAProjectObjective: "Veuillez sélectionner un objectif de projet",
    oneOnOne: "( 1 - 1 )",
    oneOnOneOrPlant: " ( 1 - 1 ) ou Centrale",
    projectName: "Nom du projet",
    doYouWantSave: "Voulez-vous enregistrer vos données dans le cloud avant de fermer ?",
    start: "Démarrer",
    quickNavigation: "Navigation rapide",

    establishBaseline: "Établir une base",
    profile: "Données personnelles",
    siteObservation: "Observation sur le terrain",
    equipmentSpecification: "Spécifications de l'équipement",
    baselineInput: "Entrée de base",
    summary: "Résumé",
    generateReport: "Générer un rapport",

    finalizeYourProposal: "Finaliser votre proposition",
    retrofitSetup: "Paramètres de modification",
    equipmentRated: "Device rating",
    financialAnalysis: "Analyse financière",
    proposedConfig: "Configuration proposée"
  },
  setup: {
    systemOption: "Option système",
    chillerOnly: "Refroidisseur seulement",
    chillerWithAssociatedEquipment: "Refroidisseur avec équipement associé",
    controlOnly: "Contrôle seulement",
    proposedLayout: "Disposition proposée",
    series: "Série",
    parallel: "Parallèle",
    proposedEquipment: "Équipement proposé"
  },
  rated: {
    newEquipment: "Nouvel équipement",
    ratedInputPower: "Puissance d'entrée nominale",
    ratedCoolingCapacity: "Capacité de refroidissement nominale",
    chillerLabel: "Étiquette du refroidisseur",
    type: "Type",
    chillerBrandModel: "Marque et modèle du refroidisseur",
    yearInstalled: "Année d'installation",
    ratedDesignFlowRate: "Débit nominal de conception",
    pressureHead: "Hauteur de manomètre",
    vfd: "Si un variateur de fréquence est installé",
    yes: "Oui",
    no: "Non",
    noofFansCT: "Nombre de ventilateurs/CT",
    equipmentLabel: "Étiquette de l'équipement",
    category: "Catégorie",
    brand: "Marque",
    otherEquipment: "Autre équipement",
    inputEcatPerformanceData: "Saisir les données de performance Ecat",
    load: "Charge",
    coolingLoad: "Charge de refroidissement",
    inputPower: "Puissance d'entrée",
    chillerWaterPumpLabel: "Étiquette de la pompe à eau réfrigérée",
    ratedMotorFrequency: "Fréquence nominale du moteur",
    minimumMotorFrequency: "Fréquence minimale du moteur",
    motor: "Moteur",
    applicableChiller: "Refroidisseur applicable",
    condenserWaterPumpLabel: "Étiquette de la pompe à eau de condensation",
    coolingTowerLabel: "Étiquette de la tour de refroidissement",
    ratedFanFrequency: "Fréquence nominale du ventilateur",
    minimumFanFrequency: "Fréquence minimale du ventilateur",
    totalRatedFanPowerPerCT: "Puissance nominale totale du ventilateur par CT",
    heatRejectionCapacityPerCT: "Capacité de rejet de chaleur par CT",
    chillerLabelRequired: "L'étiquette du refroidisseur est obligatoire",
    yellowBlockRequired: "Le bloc jaune est obligatoire",
    labelRequired: "L'étiquette est obligatoire",
    maximumQuantity: "Quantité maximale"
  },
  summary: {
    chooleYourPreference: "Choisissez votre préférence",
    higherEfficiencyImprovement: "Améliorer l'efficacité",
    lowerInvestment: "Investissement plus faible",
    higherCostSaving: "Économie de coûts plus élevée",
    shorterPaybackPeriod: "Période de remboursement plus courte",
    option: "Option",
    efficiencyImprovement: "Amélioration de l'efficacité",
    returnOnInvestment: "Retour sur investissement",
    costSavingsPerYear: "Économie de coûts par an",
    paybackPeriod: "Période de remboursement",
    optionDetails: "Détails de l'option",
    postRetrofitEfficiency: "Efficacité après rénovation",
    totalEnergySavingsPerYear: "Économie totale d'énergie par an",
    investmentAnalysis: "Analyse d'investissement",
    capex: "CAPEX",
    sellingPrice: "Prix de vente",
    chillerCooling: "Refroidissement par refroidisseur",
    chillerHeatPump: "Pompe à chaleur refroidisseur",
    calculate: "Calculer",
    proposedConfig: "Configuration proposée",
    projectIntroduction: "Introduction du projet",
    assumptions: "Hypothèses",
    chillerPlant: "Installation de refroidissement",
    chillerPlantConfig: "Configuration de l'installation de refroidissement",
    peakBuildingCoolingLoad: "Charge de refroidissement maximale du bâtiment",
    designChilledWaterSupplyTemp: "Température de distribution de l'eau réfrigérée conçue",
    designCondenserWaterSupplyTemp: "Température de distribution de l'eau de condensation conçue",
    energyConservationMeasures: "Mesures de conservation de l'énergie",
    pumpingConfig: "Configuration de pompage",
    designFlowRate: "Débit conçu",
    designPressureHead: "Tête de pression conçue",
    vfdFitted: "VFD installé",
    chillerConfig: "Configuration du refroidisseur",
    condenserWaterPump: "Pompe à eau de condensation",
    coolingTowerConfig: "Configuration de la tour de refroidissement",
    heatRejectionCapacity: "Capacité de rejet de chaleur",
    designCoolingTowerApproach: "Approche de la tour de refroidissement conçue",
    generateReport: "Générer un rapport",
    confirmCalculation: "Confirmer le calcul",
    doYouNeedCalculationAgain: "Le résultat du calcul existe déjà. Avez-vous besoin de recalculer ?",
    recalculate: "Recalculer",
    coolingTower: "Tour de refroidissement",
    chiller: "Refroidisseur",
    chilledWaterPump: "Pompe à eau réfrigérée",
    fillValidNumericalValue: "Veuillez remplir une valeur numérique valide"
  },
  profileMap: {
    associatedChiller: "Carte de machine froide",
    associatedCT: "Cartographie de la tour de refroidissement",
    associatedCWP: "Cartographie CWP",
    associatedCHWP: "Cartographie CHWP",
    profileId: "Id de profil",
    donotNeedmanipulate: "En mode automatique, vous n'avez pas besoin de manipuler le profil.",

    automatic: "Automatiquement",
    manual: "Le manuel",
    pathAndMethod: "Chemins et méthodes",
    months: "Mois",
    running: "Courir",
    daysPerMonth: "Jours / mois",
    chiller: "Le refroidisseur"
  }
}



// WEBPACK FOOTER //
// ./src/locale/post/fr.js